import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { listCategories } from '../Actions/categoryActions';
import './CategorySelector.css';

export default function CategorySelector({ selectedCategories, onCategoryChange }) {
    const dispatch = useDispatch();
    const categoryList = useSelector((state) => state.categoryList);
    const { loading, error, categories } = categoryList;

    useEffect(() => {
        dispatch(listCategories());
    }, [dispatch]);

    const handleCategoryToggle = (categoryId) => {
        const updatedCategories = selectedCategories.includes(categoryId)
            ? selectedCategories.filter(id => id !== categoryId)
            : [...selectedCategories, categoryId];
        
        onCategoryChange(updatedCategories);
    };

    if (loading) {
        return <div className="category-selector-loading">Loading categories...</div>;
    }

    if (error) {
        return <div className="category-selector-error">Error loading categories: {error}</div>;
    }

    if (!categories || categories.length === 0) {
        return <div className="category-selector-empty">No categories available</div>;
    }

    // Filter categories: only show if isShow="Yes" and exclude "Home" category
    const filteredCategories = categories.filter(category => {
        const categoryName = (category.categoryName || '').toLowerCase();
        const isShow = (category.isShow || '').toLowerCase();
        
        // Exclude "Home" category and only show categories with isShow="Yes"
        return categoryName !== 'home' && isShow === 'yes';
    });

    if (filteredCategories.length === 0) {
        return <div className="category-selector-empty">No categories available for selection</div>;
    }

    return (
        <div className="category-selector">
            <div className="category-selector-header">
                <h4>Select Business Categories</h4>
                <p className="category-selector-subtitle">
                    Choose the categories your business deals in
                </p>
            </div>
            <div className="category-grid">
                {filteredCategories.map((category) => (
                    <label 
                        key={category.id} 
                        className={`category-checkbox-item ${selectedCategories.includes(category.id) ? 'selected' : ''}`}
                    >
                        <input
                            type="checkbox"
                            checked={selectedCategories.includes(category.id)}
                            onChange={() => handleCategoryToggle(category.id)}
                            className="category-checkbox-input"
                        />
                        <div className="category-checkbox-content">
                            {category.icon && (
                                <img 
                                    src={category.icon} 
                                    alt={category.categoryName}
                                    className="category-icon"
                                />
                            )}
                            <span className="category-name">{category.categoryName}</span>
                            {selectedCategories.includes(category.id) && (
                                <span className="category-checkmark">✓</span>
                            )}
                        </div>
                    </label>
                ))}
            </div>
            {selectedCategories.length > 0 && (
                <div className="category-selected-count">
                    {selectedCategories.length} {selectedCategories.length === 1 ? 'category' : 'categories'} selected
                </div>
            )}
        </div>
    );
}
